// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const buscarEmpreendimentosPostagemService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/empreendimento/`;
    let empreendimentos: any[] = [];
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
     
      response.data.map((p: any) => {
        if(p.origem === 0||p.origem === 2){
          empreendimentos.push(p);
        }
      });
     
      if (response && response.data) {
        
        return empreendimentos;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
